import { createSlice } from '@reduxjs/toolkit';
import { startLoader, stopLoader } from './loaderSlice';
import { AlertPopup } from '../../../Asset/common';
import { HttpMethod } from '../../../Asset/httpMethod';

const initialState = {
  loading: false,
  userData: null,
};

export const fetchUserProfile = () => async (dispatch) => {
  dispatch(startLoader());
  try {
    const res = await HttpMethod.get('/Authorization/Account/Profile');
    if (res?.status === 200 && res.data) {
      dispatch(getUserData(res.data));  // store data in state
      dispatch(stopLoader());
      return res.data;
    } else {
      dispatch(stopLoader());
      AlertPopup.warningPopup("Failed to load profile data.");
      return null;
    }
  } catch (error) {
    dispatch(stopLoader());
    AlertPopup.errorPopup("Error fetching profile data.");
    return null;
  }
};

const UserProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    getUserData: (state, action) => {
      state.userData = action.payload;
    },
  },
});

export const { getUserData } = UserProfileSlice.actions;
export default UserProfileSlice.reducer;
